import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardMembershipDetailsDocument,
  type DashboardMembershipDetailsQuery,
  type DashboardMembershipDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_MEMBERSHIP_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const id = props.params.id;
  if (!id) throw new Error("undefined id");

  const { data } = await client.query<
    DashboardMembershipDetailsQuery,
    DashboardMembershipDetailsQueryVariables
  >({
    query: DashboardMembershipDetailsDocument,
    fetchPolicy: "network-only",
    variables: { id },
  });

  return data;
};
